<template>
  <div class="container">
    <Head v-if="meta.title" v-bind:meta="meta"></Head>
    <Header></Header>
    <Navigation></Navigation>
    <Breadcrumbs
      v-if="breadcrumbs"
      v-bind:breadcrumbs="breadcrumbs"
    ></Breadcrumbs>
    <advanced-search-content v-if="tags" :tags="tags" :collections="collections"/>
    <Footer></Footer>
  </div>
</template>

<script>
// libraries
import Vivus from "vivus"; // ?
import axios from "axios";
import NProgress from "nprogress";

// components

import Head from "@/components/Common/Head.vue";
import Header from "@/components/Header/Header.vue";
import AdvancedSearchContent from "@/components/AdvancedSearch/AdvancedSearchContent.vue";
import Navigation from "@/components/Common/Navigation.vue";
import Footer from "@/components/Footer/Footer.vue";
import Breadcrumbs from "@/components/Common/Breadcrumbs.vue";

// https://fizykoteka.ckc.uw.edu.pl/omeka/api/items?item_type=FizykotekaBiogram

// functions

export default {
  name: "AdvancedSearch",
  components: {
    Head,
    Header,
    Navigation,
    AdvancedSearchContent,
    Breadcrumbs,
    Footer,
  },
  data() {
    return {
      fbShareURL:
        "https://www.facebook.com/sharer/sharer.php?u=" + window.location.href,
      meta: {
        url: window.location.href,
        description: "",
        title: "",
        og_type: "website",
        og_image: "",
      },
      breadcrumbs: {
        parent_title: "",
        parent_uri: "",
        self_title: "",
        self_uri: window.location.href,
      },
      // requests
      page: 1,
      apiCall: null,
      collections: null,
      tags: null,
    };
  },
  methods: {
    fetchCollections() {
      NProgress.start();
      axios
        .get(this.$config.API_PATH + "collections?page=" + this.page)
        .then((_resp) => {
          let _total_results = Number(_resp.headers["omeka-total-results"]);

          if (!this.collections) this.collections = [];

          _resp.data.forEach((_e) => {
            this.collections.push(_e);
          });

          if (this.collections.length != _total_results) {
            this.page++;
            this.fetchCollections();
          } else {
            NProgress.done();

            // parse collections, we need id and title and items count

            let _collections = [];

            this.collections.forEach((_c) => {
              let _metadata = _c.element_texts;
              let _title = "Bez tytułu";

              if (_metadata.find((x) => x.element.id == "50"))
                _title = _metadata.find((x) => x.element.id == "50").text;

              _collections.push({
                id: _c.id,
                title: _title,
                count: _c.items.count,
              });
            });

            _collections.sort(function (a, b) {
              var textA = a.title.toUpperCase();
              var textB = b.title.toUpperCase();
              return textA < textB ? -1 : textA > textB ? 1 : 0;
            });

            this.collections = _collections;
            this.page = 1;
            this.fetchTags();
          }
        });
    },
    fetchTags() {
      NProgress.start();
      axios
        .get(this.$config.API_PATH + "tags?page=" + this.page)
        .then((_resp) => {
          let _total_results = Number(_resp.headers["omeka-total-results"]);

          if (!this.tags) this.tags = [];

          _resp.data.forEach((_e) => {
            this.tags.push(_e);
          });

          if (this.tags.length != _total_results) {
            this.page++;
            this.fetchTags();
          } else {
            NProgress.done();

            // parse tags, we need id and name and items count

            let _tags = [];

            this.tags.forEach((_t) => {
              _tags.push({
                id: _t.id,
                name: _t.name,
              });
            });

            _tags.sort(function (a, b) {
              var textA = a.name.toUpperCase();
              var textB = b.name.toUpperCase();
              return textA < textB ? -1 : textA > textB ? 1 : 0;
            });

            this.tags = _tags;
          }
        });
    },
  },
  destroyed() {},
  created() {
    this.fetchCollections();
  },
  watch: {
    //'$route': 'fetchData',
    /* page:  function(v) {
            if(this.meta.og_image) {
                this.meta.og_image = this.page.ckc_cover_image
            } else {
                this.meta.og_image = require("@/assets/img/default.jpg")
            }
            
        } */
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/AdvancedSearch/AdvancedSearch.vue